import Reveal from "@/components/site/Reveal";

const steps = [
  {
    title: "Accueil et présentation du cadre",
    desc: "Tour de table, confidentialité, posture attendue, déroulé de la journée.",
  },
  {
    title: "Choix d'une problématique",
    desc: "Une situation est posée, écoutée, précisée — sans interprétation hâtive.",
  },
  {
    title: "Mise en place de la constellation",
    desc: "Des places sont représentées dans l'espace par les participants du groupe.",
  },
  {
    title: "Observation et mise en mouvement",
    desc: "Ce qui apparaît est observé, puis quelques ajustements sont proposés.",
  },
  {
    title: "Temps d'intégration",
    desc: "Retour collectif, ancrage individuel. Ce qui a été vu est laissé déposer.",
  },
];

export default function CHowItWorks() {
  return (
    <section
      id="how"
      data-testid="c-how"
      className="py-24 md:py-32 bg-[#FAF7F8] scroll-mt-24"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Déroulé
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Comment se déroule un atelier
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 relative">
          <div
            aria-hidden
            className="hidden md:block absolute top-6 left-[3.5rem] right-[3.5rem] h-px bg-[#DDD7E2]"
          />
          <div className="grid md:grid-cols-5 gap-6 md:gap-3 relative">
            {steps.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.07}>
                <div
                  data-testid={`c-how-step-${i}`}
                  className="relative p-6 bg-white rounded-3xl border border-[#DDD7E2] h-full"
                >
                  <div className="w-12 h-12 rounded-full bg-[#3A2E6E] text-white flex items-center justify-center font-serif-display text-xl mx-auto -mt-12 mb-5 border-4 border-[#FAF7F8] relative z-10">
                    {i + 1}
                  </div>
                  <h3 className="font-serif-display text-lg text-[#1E1E2A] text-center leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-[#5F6170] leading-relaxed text-center">
                    {s.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
